import { useEffect, useRef } from 'react';
import { useSettings, useUI } from '../contexts';

type UseApiSyncParams = {
  refreshToken: () => Promise<string | null>;
  setCacheVersion: React.Dispatch<React.SetStateAction<number>>;
};

export function useApiSync({
  refreshToken,
  setCacheVersion,
}: UseApiSyncParams) {
  // Get settings from context
  const { apiBase, apiKey, apiSecret } = useSettings();

  // Get UI state from context
  const { setStatus } = useUI();
  const apiBaseInitRef = useRef(false);
  const credsInitRef = useRef(false);

  // Handle API base changes
  useEffect(() => {
    if (apiBaseInitRef.current) {
      setStatus('API base değişti, yeniden bağlanılıyor…');
      setCacheVersion((v) => v + 1);
      void refreshToken();
    } else {
      apiBaseInitRef.current = true;
    }
  }, [apiBase, refreshToken, setStatus, setCacheVersion]);

  // Handle credentials changes
  useEffect(() => {
    if (credsInitRef.current) {
      setStatus('Kimlik bilgileri güncellendi, token yenileniyor…');
      void refreshToken();
    } else {
      credsInitRef.current = true;
    }
  }, [apiKey, apiSecret, refreshToken, setStatus]);
}
